<script setup lang="ts">
defineProps<{
  id?: string
  title?: string
}>()
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 920 217.18" width="920" height="217.18">
    <rect width="920" height="217.18" />
    <path
      d="M133.76,136c0,21.9-18,40.86-40.08,40.86H40.5V40H92.7a37,37,0,0,1,37,37c0,12.51-7,21.31-14.07,27.57C126.33,110.36,133.76,121.51,133.76,136ZM60.44,58.55V96.28H89.38c11.53,0,19.55-8.4,19.55-19.16,0-10.36-7.82-18.57-19.55-18.57Zm29.92,98.93C104,157.48,113,147.9,113,136c0-12.51-9-21.7-22.68-21.7H60.44v43.21Z"
      fill="#fff"
    />
    <path d="M155.46,40h75.86V59H175.4V96.32h54.16V114.7H175.4v42.62h57.09v19.55h-77Z" fill="#fff" />
    <path d="M256.54,40h19.94v117.3H332.4v19.55H256.54Z" fill="#fff" />
    <path d="M351.76,40H371.7V176.83H351.76Z" fill="#fff" />
    <path
      d="M521.46,147.9H471l-11.54,28.93H438.37L496.24,37.42l57.87,139.39H533Zm-43.4-17.79h36.17L496.23,84Z"
      fill="#fff"
    />
    <path
      d="M636.22,136,682,37.42l25.81,139.39H687.06L673.57,99.22l-37.35,80.2-37.34-80.2-13.49,77.61H564.67l25.8-139.41Z"
      fill="#fff"
    />
    <path
      d="M723.62,108.6c0-39.3,29.52-71,70.19-71S864,69.3,864,108.6c0,39.1-29.52,70.78-70.18,70.78S723.62,147.7,723.62,108.6Zm20.92,0c0,29.52,20.92,51.23,49.27,51.23s49.26-21.71,49.26-51.23c0-29.72-20.92-51.42-49.26-51.42S744.54,78.88,744.54,108.6Z"
      fill="#fff"
    />
    <path d="M892.73,153.18a13.1,13.1,0,1,1-13.09,13.11h0a13.09,13.09,0,0,1,13.08-13.1Z" fill="#fff" />
  </svg>
</template>
